import { showConfirmationScreen } from "./util";
import { updateDbWithDefaultFormValues } from "../api";

export const postSubmitToDBPipe = ($form, formValues) => {
  //  update the table
  if (formValues) {
    updateDbWithDefaultFormValues(formValues).then((responseData, response) => {
      const isDbUpdated = response === "success";
      const formName = $form.attr("name");

      const apiName = formName;
      // string, e.g. 'marketo-submit-success-1842' for the getStarted form
      window?.intellimize?.sendEvent(apiName);

      if (isDbUpdated) {
        showConfirmationScreen(formName);
      }
    });
  }
};
